export var SkinId;
(function (SkinId) {
    SkinId["Arcane"] = "arcane";
    SkinId["LoL"] = "lol";
    SkinId["Riot"] = "riot";
    SkinId["RiotProduct"] = "riot-product";
    SkinId["RiotProductLion"] = "riot-product-lion";
    SkinId["TFT"] = "tft";
    SkinId["Valorant"] = "valorant";
    SkinId["WildRift"] = "wildrift";
    SkinId["LeagueClient"] = "league-client";
    SkinId["PlayTheme"] = "play-theme";
})(SkinId || (SkinId = {}));
export const colorTokenKeys = [
    "accents1",
    "accents1_disabled",
    "accents1_hover",
    "accents2",
    "accents2_disabled",
    "accents2_hover",
    "bladetext1",
    "bladetext1_light",
    "bladebg1",
    "bladetext2",
    "bladebg2",
    "bladetext3",
    "bladebg3",
    "bladebg3_hover",
    "bladebg3_disabled",
    "bladetext_ulc",
    "underlay",
    "keyline",
    "ctatext1",
    "ctatext1_disabled",
    "ctatext1_hover",
    "ctabg1",
    "ctabg1_disabled",
    "ctabg1_hover",
    "ctastroke1",
    "ctastroke1_hover",
    "ctastroke1_disabled",
    "ctatext2",
    "ctatext2_disabled",
    "ctatext2_hover",
    "ctabg2",
    "ctabg2_disabled",
    "ctabg2_hover",
    "ctastroke2",
    "ctastroke2_hover",
    "ctastroke2_disabled",
];
export const colorPaletteValidNames = ["palette1", "palette2", "palette3"];
//# sourceMappingURL=types.js.map